// extracted by mini-css-extract-plugin
export var avatarContainer = "_5w-0";
export var avatarTypingWave = "_5w-i";
export var gray = "_5w-f";
export var green = "_5w-c";
export var icon = "_5w-9";
export var image = "_5w-1";
export var lg = "_5w-6";
export var md = "_5w-5";
export var presenceDot = "_5w-b";
export var red = "_5w-d";
export var sm = "_5w-4";
export var status = "_5w-a";
export var typingDot = "_5w-h";
export var typingPill = "_5w-g";
export var xl = "_5w-7";
export var xs = "_5w-3";
export var xxl = "_5w-8";
export var xxs = "_5w-2";
export var yellow = "_5w-e";